<template>
  <div>
    <div class="filter">
      <ul>
        <li @click="exportTPDF">导出</li>
      </ul>
    </div>
    <div class="table">
      <el-row type="flex" align="middle" v-if="reportTable">
        <el-col :span="24">
          <table border v-for="(item, i) in reportTable" :key="i" :class="{ tab: !item }">
            <tbody v-if="item">
              <tr>
                <td rowspan="9" style="width: 100px;">
                  <div class="px">
                    平行志愿{{ i + 1 }}
                  </div>
                  <div class="del" v-if="item">
                    <el-button round size="mini" type="danger" plain @click="delCollege(item, i)">删除</el-button>
                  </div>
                  <div class="huanwei" v-if="item">
                    <el-popover popper-class="popover-f" placement="bottom" trigger="hover">
                      <div class="popover-box">
                        <p class="box-title">志愿位置</p>
                        <span v-for="h in len" :key="h" class="box-item" @click="changeCollege(h - 1, i)">
                          <span v-if="record.id_list[h - 1] != ''" class="box-item-box"
                            style="background: #fbbfbb; border: #fbbfbb;">{{ h }}</span>
                          <span v-else class="box-item-box">{{ h }}</span>
                        </span>
                      </div>
                      <el-button round size="mini" slot="reference" type="primary" plain>换位</el-button>
                    </el-popover>
                  </div>
                </td>
                <td colspan="6">
                  <p class="row" style="color:#adadad">
                    <span style="margin-right: 2px;font-size: 18px; color: black; font-weight: bold; "
                      v-if="item.name">{{ item.name
                      }}</span>
                    <span v-if="item.group_name" style="font-size: 16px;margin-left: 5px;color: black;">【{{
                      item.group_name }}】</span>
                    <span v-if="item.school_tip">
                      {{ item.school_tip }} |
                    </span>
                    <span v-if="item.nature">{{ item.nature }} | </span>
                    <span v-if="item.school_type">{{ item.school_type }} | </span>
                    <span v-if="item.school_belong"> {{ item.school_belong }} |</span>
                    <span v-if="item.address" style=" white-space: nowrap">
                      <el-tooltip class="item" :content="item.address" placement="top-end" effect="light">
                        <span> {{ item.address }} | </span>
                      </el-tooltip>
                    </span>
                    <span v-if="item.baoyan">保研 | </span>
                    <span v-if="item.ruanke">排名：{{ item.ruanke }}</span>
                    <span style="margin-left: 15px;"><span style="color: #adadad;">{{ item.pici }}</span></span>
                  </p>
                  <p style="margin-top: 10px;font-size: 18px; ">{{ item.specialty_id }}{{ item.specialty_name }}</p>
                  <p style="color:#adadad;margin-top: 10px;font-size: 16px;  white-space: nowrap;overflow: hidden;
  text-overflow: ellipsis; ">
                    <span>专业信息：<span style="color: #000000;">{{ item.remarks }}</span></span>
                  </p>
                  <p style="color:#adadad;margin-top: 10px;font-size: 16px;  white-space: nowrap;overflow: hidden;
  text-overflow: ellipsis; ">
                    <span>院校代码：<span style="color: #000000;">{{ item.school_id }}</span></span>
                    <span style="margin-left: 15px;">招生计划： <span style="color: #000000;"> {{ item.plan_num }}</span>
                    </span>
                    <span style="margin-left: 15px;">选科要求：<span style="color: #000000;">{{ item.demand
                    }}</span></span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" v-if="!reportTable">
        <el-col :span="24">
          <div style="margin-top: 20px; text-align: center;"> 暂无志愿表，请先添加</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: ['userInfo', 'batch_copy'],
  data() {
    return {
      record: [],
      reportTable: [],
      len: 64
    };
  },
  computed: {
  },
  created() {
    this.getReport_t()
  },
  methods: {
    //提前批类志愿表
    getReport_t() {
      let data = {
        user_id: this.$route.query.id,
        subject: this.userInfo.subject,
        new_batch: this.batch_copy,
      }
      this.$fecth.post("volunteer_tiqian/get_report_tiqian", data).then((res) => {
        if (res.data.record) {
          this.record = JSON.parse(res.data.record)
          this.reportTable = this.record.table.slice(0, 64)
        } else {
          this.reportTable = null
        }
      })
    },
    exportTPDF() {
      this.$router.push(
        "/report_tiqian?id=" +
        this.userInfo.id + '&new_batch=' + this.batch_copy
      );
    },
    delCollege(item, k) {
      this.record.id_list[k] = ''
      this.record.table[k] = {
        name: '暂无'
      }
      this.reportTable = this.record.table.slice(0, 64)
      this.updateReport(this.record)
    },
    changeCollege(h, i) {
      this.record.table = this.moveElementInArray(this.record.table, i, h)
      this.record.id_list = this.moveElementInArray(this.record.id_list, i, h)
      this.updateReport(this.record)
    },
    //更新志愿表
    updateReport(record) {
      this.$fecth
        .post("volunteer_tiqian/updateReport", {
          user_id: this.userInfo.id,
          subject: this.userInfo.subject,
          new_batch: this.batch_copy,
          record: JSON.stringify(record)
        })
      this.state++
      this.reportTable = this.record.table.slice(0, 64)
    },
    moveElementInArray(array, fromIndex, toIndex) {
      const element = array.splice(fromIndex, 1)[0];
      array.splice(toIndex, 0, element);
      return array
    },
  },
};
</script>


<style scoped lang='less'>
.report {
  width: 1200px;
  margin: 0 auto;
  background: white;

  .score-table {
    font-size: 12px;
    color: #B5B3B3;
    border: 0;

    td {
      padding: 0;
      text-align: center;

    }
  }
}

.filter {
  padding: 0 52px;
  margin-top: 15px;
  height: 40px;

  ul {
    display: inline-block;
    list-style: none;
    position: relative;
    top: 7px;
  }

  li {
    float: left;
    width: 77px;
    text-align: center;
    margin-left: 13px;
    border: 1px solid #707070;
    border-radius: 19px;
    padding: 2px 5px;
  }

  li:hover {
    background: #459df6;
    color: white;
    border: #459df6;
  }



  .level {
    background: #459df6;
    color: white;
    border: #459df6;
  }
}

.top {
  margin-top: 20px;
  border-bottom: 4px solid #459EFF;
  height: 40px;
}

.right {
  float: right;
  height: 36px;

  ul {
    display: inline-block;
    list-style: none;
  }

  li {
    float: left;
    margin-left: 10px;
    height: 36px;
    padding: 17px;
    line-height: 3px;
    border-radius: 5px 5px 0 0;
  }

  li:hover {
    color: white;
    background: #459EFF;
    border-bottom: 1px solid #459EFF;
  }

}

.nav {
  color: white;
  background: #459EFF;
  border-bottom: 1px solid #459EFF;
}

.table {
  padding: 0 40px;
  margin: 0 auto;

  table {
    font-size: 14px;
    width: 100%;
    border-collapse: collapse;
    margin-top: 30px;
    border: 1px solid #dddddd;
    margin-bottom: 10px;

    .th {
      font-size: 16px;
      background: #f4f7fc;
      line-height: 35px;

      .name {
        font-size: 18px;
        font-weight: bold;
      }

      span {
        margin-right: 15px;
      }

      .col {
        margin-left: 0;
        color: #459df6;
      }
    }

    .th,
    td {
      line-height: 35px;
      padding: 5px 13px;
    }

    .td-height {
      .remarks {
        max-height: 40px;
        overflow: hidden;
      }
    }
  }

  .del {
    text-align: center;
    margin-bottom: 10px;
  }

  .huanwei {
    text-align: center;
    margin-bottom: 10px;
  }
}


.tab {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}





.px {
  margin-top: 20px;
  text-align: center;
  font-size: 14;
  margin-bottom: 10px;
}

.fc {
  text-align: center;
  color: #459df6;
  margin-bottom: 10px;
}
</style>


<style lang="less">
.mojarDialog {
  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }
}
</style>